import { FrontendProductSchema } from "@redotech/redo-model/agents/support-agents/frontend-product";
import * as z from "zod/v4";

export const searchProducts = {
  name: "searchProducts" as const,
  input: z.object({
    query: z.string(),
  }),
  output: z.array(FrontendProductSchema),
};
